import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=0fc6c088&scoped=true&"
import script from "./CommonDialog.vue?vue&type=script&lang=js&"
export * from "./CommonDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommonDialog.vue?vue&type=style&index=0&id=0fc6c088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6c088",
  null
  
)

export default component.exports